import { render, staticRenderFns } from "./AddCooprateDialog.vue?vue&type=template&id=3fa49c6a&scoped=true"
import script from "./AddCooprateDialog.vue?vue&type=script&lang=js"
export * from "./AddCooprateDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCooprateDialog.vue?vue&type=style&index=0&id=3fa49c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa49c6a",
  null
  
)

export default component.exports